import React, { useEffect, useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router-dom';

interface GameNotFoundDialogProps {
  gameId: number;
  redirectUrl?: string;
  autoRedirectSeconds?: number;
}

export const GameNotFoundDialog: React.FC<GameNotFoundDialogProps> = ({
  gameId,
  redirectUrl = '/mylibrary/games',
  autoRedirectSeconds = 5
}) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(autoRedirectSeconds);

  const handleRedirect = () => {
    navigate(redirectUrl, { replace: true });
  };

  useEffect(() => {
    if (countdown <= 0) {
      handleRedirect();
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <Dialog
      title={'Game not found'}
      onClose={handleRedirect}
      width={500}
      autoFocus={true}>
      <div className={'py-2'}>
        <div className={'d-flex align-items-center mb-3 text-danger'}>
          <span
            className={'material-symbols-outlined me-2'}
            style={{ fontSize: '2.2rem' }}>
            error
          </span>
          <h5 className={'mb-0 font-weight-bold'}>Game has been deleted</h5>
        </div>
        <p className={'text-secondary mb-2'} style={{ fontSize: '14px', lineHeight: '1.5' }}>
          The game you are trying to access (ID: <strong>{gameId}</strong>) could not
          be found or has been deleted from the server.
        </p>
        <p className={'text-muted small mb-0'}>
          Redirecting to My Library in <strong>{countdown}</strong> second{countdown !== 1 ? 's' : ''}...
        </p>
      </div>
      <DialogActionsBar>
        <Button themeColor={'primary'} onClick={handleRedirect}>
          Return to My Library
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default GameNotFoundDialog;
